import { ValidationObserver } from 'vee-validate';
import Vue from 'vue';
import TextFieldWithValidation from '@/components/inputs/TextFieldWithValidation.vue';

Vue.component('TextFieldWithValidation', TextFieldWithValidation);
Vue.component('ValidationObserver', ValidationObserver);
